import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { MicrosoftOnlineEffects } from './effects/microsoft-online.effect';

@NgModule({
  imports: [EffectsModule.forFeature([MicrosoftOnlineEffects])],
})
export class MsOnlineEditingStoreModule {}
